<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>Turkey’s Modernization</h1>
<p class="subtitle"><span class="bold">Refugees from Nazism and Atatürk’s Vision</span></p>
<p class="author"><span class="bold">Arnold Reisman</span></p>
<div class="img_container1">
<img alt="image" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?5d179614